import FeaturePage from "../../components/FeaturePage";
import { Wallet, Globe2, Shield, Zap, BarChart3, Receipt } from "lucide-react";

export default function CollectPayments() {
  return (
    <FeaturePage
      badge="Collect Payments"
      title="Get paid in any currency."
      highlight="On any continent."
      subtitle="Receive local & international payments easily. Choose from payment options that allow you get paid in Naira/US Dollar, set up payment alerts, and reconcile in seconds."
      heroImage="https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="mint"
      features={[
        { icon: <Wallet size={22} />, title: "Multi-currency wallet", desc: "Hold balances in NGN, USD, GBP, EUR. Convert at competitive rates." },
        { icon: <Globe2 size={22} />, title: "150+ countries", desc: "Accept cards, wallets, bank transfers, and local methods globally." },
        { icon: <Shield size={22} />, title: "PCI-DSS compliant", desc: "Bank-grade encryption, 3DS, and fraud detection built in." },
        { icon: <Zap size={22} />, title: "Instant settlement", desc: "Same-day or T+1 payouts to your bank. No waiting weeks." },
        { icon: <BarChart3 size={22} />, title: "Real-time reporting", desc: "See every transaction the moment it happens with live dashboards." },
        { icon: <Receipt size={22} />, title: "Auto receipts", desc: "Branded receipts, invoices and refund flows delivered automatically." },
      ]}
      details={[
        {
          tag: "Payment methods",
          title: "Every payment method your customers ask for.",
          desc: "Cards, USSD, bank transfer, Apple Pay, mobile money — Brivo supports them all out of the box. Your customer chooses, you get paid.",
          bullets: ["Visa, Mastercard, Verve, Amex", "Bank transfer, USSD, QR pay", "Apple Pay & Google Pay"],
        },
        {
          tag: "Reconciliation",
          title: "Reconciliation that takes 30 seconds, not 3 hours.",
          desc: "Brivo matches every payment to every order automatically. Never chase a missing transaction again.",
          bullets: ["Auto-match payments to orders", "Daily settlement reports", "One-click export to your accountant"],
        },
        {
          tag: "Subscriptions",
          title: "Recurring revenue, made simple.",
          desc: "Set up subscription plans, retry failed cards, send dunning emails — Brivo handles the entire lifecycle.",
        },
      ]}
      useCases={[
        { title: "E-commerce", desc: "Checkout pages and one-click payments for storefronts." },
        { title: "SaaS & subscriptions", desc: "Recurring billing, prorations and trial management." },
        { title: "Marketplaces", desc: "Split payments and supplier payouts in real time." },
        { title: "Cross-border", desc: "Get paid in USD, settle in your local currency easily." },
      ]}
      ctaTitle="Stop chasing payments."
      ctaSubtitle="Brivo collects, reconciles, and pays you out — automatically."
      ctaAccent="cream"
    />
  );
}
